import { cn } from 'src/lib/utils';
import {
  getAvatarTone,
  getClientInitials,
  type ClientAvatarTone,
} from '../../utils/client-display.utils';

const TONE_CLASSES: Record<ClientAvatarTone, string> = {
  blue: 'bg-[#EFF6FF] text-[#2563EB]',
  purple: 'bg-[#EDE9FE] text-[#6D28D9]',
  green: 'bg-[#ECFDF5] text-[#059669]',
  amber: 'bg-[#FEF3C7] text-[#92400E]',
  red: 'bg-[#FEE2E2] text-[#991B1B]',
};

interface ClientAvatarProps {
  title: string;
  brand?: string | null;
  initials?: string;
  size?: number;
  className?: string;
}

export function ClientAvatar({
  title,
  brand,
  initials,
  size = 36,
  className,
}: ClientAvatarProps) {
  const tone = getAvatarTone(title);
  const label = initials ?? getClientInitials(title);
  const fontSize = size >= 48 ? 16 : size >= 36 ? 13 : 11;

  if (brand) {
    return (
      <img
        src={brand}
        alt=""
        className={cn('shrink-0 rounded-full object-cover', className)}
        style={{ width: size, height: size }}
      />
    );
  }

  return (
    <div
      aria-hidden
      className={cn(
        'flex shrink-0 items-center justify-center rounded-full font-bold',
        TONE_CLASSES[tone],
        className
      )}
      style={{ width: size, height: size, fontSize }}
    >
      {label}
    </div>
  );
}
